module.exports = __webpack_public_path__ + "static/media/diamonds_10.4b908f0c.png";